import currencyFormatter from '../../../../libs/currency-formatter.js';

export const NO_BOOST_ID = -1;
export const NO_BOOST = 'NO_BOOST';
export const MATCHED = 'MATCHED';
export const GUARANTEED = 'GUARANTEED';
export const ADD_ON = 'ADD_ON';
export const FREE_WESPIN = 'FREE_WESPIN';

export const TYPES = [NO_BOOST, MATCHED, GUARANTEED, ADD_ON, FREE_WESPIN];

export const LABEL_MAPPING = {
	[NO_BOOST]: 'No Boost',
	[MATCHED]: 'Matched',
	[GUARANTEED]: 'Guraranteed Pot',
	[ADD_ON]: 'Add-on',
	[FREE_WESPIN]: 'Free WeSpin'
};

export const getTagText = (boost, locale) =>
	`${currencyFormatter.format(boost.amount, boost.currency, locale, true)} ${LABEL_MAPPING[boost.type]}`;

const SORT_ORDER = [NO_BOOST, FREE_WESPIN, GUARANTEED, ADD_ON, MATCHED].reduce(
	(obj, item, i) => ({ ...obj, [item]: i }),
	{}
);

export const NO_BOOST_ITEM = {
	id: NO_BOOST_ID,
	type: NO_BOOST,
	title: LABEL_MAPPING[NO_BOOST],
	description: 'A regular WeSpin session for you and your viewers to indulge in together.'
};

export const BOOSTS_SORTER = (a, b) =>
	a.type === b.type ? a.boostId - b.boostId : SORT_ORDER[a.type] - SORT_ORDER[b.type];
